import React from 'react';

import CreditTermsRoutes from 'domain/finance/creditTerms/routes';
import TransactionsRoutes from 'domain/finance/transactions/routes';
import InvoicesRoutes from 'domain/finance/invoices/routes';
import ReconciliationRoutes from 'domain/finance/reconciliation/routes';
import PayablesRoutes from 'domain/finance/payables/routes';

const Routes = () => (
  <>
    <ReconciliationRoutes key="ReconciliationRoutes" />
    <PayablesRoutes key="PayablesRoutes" />
  </>
);

export default Routes;
